import { render } from "./RegisterForm.vue?vue&type=template&id=149756db&lang=true"
import script from "./RegisterForm.vue?vue&type=script&lang=js"
export * from "./RegisterForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/components/RegisterForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "149756db"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('149756db', __exports__)) {
    api.reload('149756db', __exports__)
  }
  
  module.hot.accept("./RegisterForm.vue?vue&type=template&id=149756db&lang=true", () => {
    api.rerender('149756db', render)
  })

}


export default __exports__